import api from "@/apis/bussiness/dataLakeAPI";
import Crud from "./crudBase";
var crud = new Crud("dataLake", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "id",
      code: "ip",      
    }
  },  
};
const getters = {
  ...crud.getters
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations  
};

export default {
  debug: process.env.NODE_ENV !== "production",
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
